/*
 * @Author: Alan
 * @Date: 2023-01-12 09:46:43
 * @LastEditors: Alan
 * @LastEditTime: 2023-09-12 09:00:48
 * @Description: 存款人姓名
 * @FilePath: /F1-M1-WEB-Code/components/RealyName/WalletName.js
 */
import React from 'react';
import { Form, Input } from 'antd';
import { realyNameReg } from '$ACTIONS/reg';
import { ApiPort } from "$ACTIONS/TLCAPI";
import { get } from "$ACTIONS/TlcRequest";

const { Item } = Form;

import { Select } from 'antd';
const { Option } = Select;

const ENUM_WALLET_NAME_TYPE = {
    RegisteredName:'RegisteredName',
    SecondaryName:'SecondaryName',
    ThirdPartyDepositorName:'ThirdPartyDepositorName',
}

const AutoSuggestLst = ({ setFieldsValue, targetInputName, isShow, items }) => {
    return (
        <ul className="auto-suggest-lst" style={{display: isShow ? 'block':''}}>
        {items.map(v=><li onClick={(t => () => {
            setFieldsValue({[targetInputName]: t})
        })(v.txt)}>{v.txt}</li>)}
        </ul>
    )
}

class WalletName extends React.Component {
	static defaultProps = {
		showDepositorNameField: false,
		prefillRegisteredName: false
	};
	constructor(props) {
		super(props);
		this.state = { nameList: [], isShowAutoSuggestLst: false, aryAutoSuggestDepositNames: [], registeredName:undefined, hideFakeDefaultValueUI:false };

		this.accessAccountName = [ 'BC', 'BCM', 'OA', 'WC', 'PPB', 'UP', 'ODP' ];

        const fakeSelectDefaultValueStyle = {position:'absolute',margin:'-50px 0 0 12px',width:300};
        this.fakeSelectDefaultValueStyle4Disable = Object.assign({}, fakeSelectDefaultValueStyle, {color:'#999'
                        ,background:'#e8e8e8'}); // avoid two black text display to member
        this.fakeSelectDefaultValueStyle4Enable = Object.assign({}, fakeSelectDefaultValueStyle, {color:'#222'
                        ,background:'#fff'}); // avoid two black text display to member
	}
    componentDidMount() {
        get(ApiPort.GetDepositorNames).then(res => {
            if (!res || !res.isSuccess || !Array.isArray(res.result)) {
                return;
            }
            this.setState({
                registeredName:res.result.find(v=>v.type===ENUM_WALLET_NAME_TYPE.RegisteredName)?.name,
                nameList: res.result.map(v=>({txt:v.name}))})
        })
    }
    _workaroundSelectDefaultValueDoesNotWorkInAntForm(val) {
        if (this._isRunningWorkaroundSelectDefaultValueDoesNotWorkInAntForm) {
            return;
        }
        this._isRunningWorkaroundSelectDefaultValueDoesNotWorkInAntForm = true;
        const targetInputName = 'accountHolderName';
        this.props.antForm.setFieldsValue({[targetInputName]: val})
    }
	render() {
		const { payTypeCode, getFieldDecorator, showDepositorNameField, prefillRegisteredName } = this.props;

        let HIDE_DEPOSITOR_NAME_FIELD = !showDepositorNameField && !prefillRegisteredName;
        if (HIDE_DEPOSITOR_NAME_FIELD) { // for KYC-76 KYC-86
            return null;
        }

		const isDisplay2023DepositNameLabel = this.props.isc2c
																					|| payTypeCode=='ODP' // <-- ticket2143
																					;
		const isDisplayNewer2023Text = isDisplay2023DepositNameLabel;

		let maxLength = /([0-9]+),([0-9]+)}\$/.exec(realyNameReg.toString());
		if (maxLength) { maxLength = maxLength[2]; }

        if (!this.accessAccountName.includes(payTypeCode)) {
            return null;
        }

        const IS_PREFILL_REGISTERED_NAME = showDepositorNameField && prefillRegisteredName;
        const isKYC = true; // Phase1: always true; Phase2: will be false // this.props.isKYC;
        const b1 = showDepositorNameField && !prefillRegisteredName && isKYC; // auto-suggestion
        const b2 = showDepositorNameField && !prefillRegisteredName && !isKYC; // pure textField no auto-suggestion
        const b3 = IS_PREFILL_REGISTERED_NAME && isKYC; // <Select /> (max: 2 options)
        const b4 = IS_PREFILL_REGISTERED_NAME && !isKYC; // <Select /> (max: 3 or 4 options)
        const IS_SHOW_SELECT = b3 || b4;

        const aryDepositNames = this.state.nameList;

        const tmp1 = Array.isArray(aryDepositNames) && aryDepositNames.length ? aryDepositNames[0].txt : undefined;
        const tmp2 = this.state.registeredName;
        //console.log('debug1015', aryDepositNames, '#'+tmp1,'#'+tmp2, b1, b2, b3, b4,'IS_SHOW_SELECT',IS_SHOW_SELECT, this.state.hideFakeDefaultValueUI);
		return (<div className={b1 ? "has-auto-suggest-lst" : ''}>
			<Item
				label={
					<div>
						存款人姓名
						{/* <span className="theme-color"> *</span> */}
					</div>
				}
			>
				{(b1 || b2) && getFieldDecorator('accountHolderName', {
					rules: [
						{ required: true, message: '请输入存款人姓名' },
						{
							validator: (rule, value, callback) => {
								if (value) {
									if (!realyNameReg.test(value)) {
										callback('格式不正确');
									}
									this.setState({aryAutoSuggestDepositNames:
										this.state.nameList.filter(v=>v.txt?.includes(value))});
								}
								if (this._isPendingToShowAutoSuggestLst) {
								this.setState({isShowAutoSuggestLst: !!value})
								}
								callback();
							}
						}
					]
                })(<Input
                    onKeyDown={()=>{this._isPendingToShowAutoSuggestLst=true}}
                    onKeyUp={()=>{this._isPendingToShowAutoSuggestLst=false}}
                    onBlur={()=>setTimeout(()=>this.setState({isShowAutoSuggestLst:false}), 150)} size="large" maxLength={maxLength} autoCapitalize="false" placeholder={'请输入存款人姓名'} />)}
            {IS_SHOW_SELECT && aryDepositNames.length>0 && getFieldDecorator('accountHolderName', {
                })(<Select
                    // defaultValue={aryDepositNames[0].txt} does not work when putting in antForm
                    disabled={aryDepositNames.length<=1}
                    placeholder={''}
                    className={'alike-digital-coin-select'}
                    onChange={t => this.setState({hideFakeDefaultValueUI:true})}
                    >{aryDepositNames.map((item, idx) => <Option style={{textAlign:'left',fontWeight:'normal'}} key={item.txt} value={item.txt}>{item.txt}</Option>)}</Select>
                    )}
            {/*TODO IS_SHOW_SELECT && aryDepositNames.length===0 && <div>empty data</div>*/}
			</Item>
			{IS_SHOW_SELECT && aryDepositNames.length===1 && !this.state.hideFakeDefaultValueUI
				&& (this._workaroundSelectDefaultValueDoesNotWorkInAntForm(tmp1), <div style={this.fakeSelectDefaultValueStyle4Disable}>{tmp1}</div>)}
			{IS_SHOW_SELECT && aryDepositNames.length>1 && !this.state.hideFakeDefaultValueUI
				&& (this._workaroundSelectDefaultValueDoesNotWorkInAntForm(tmp2), <div style={this.fakeSelectDefaultValueStyle4Enable}>{tmp2}</div>)}
			{b1 && this.state.aryAutoSuggestDepositNames?.length>0
				&& <AutoSuggestLst
					setFieldsValue={this.props.antForm.setFieldsValue}
					targetInputName="accountHolderName"
					isShow={this.state.isShowAutoSuggestLst}
					items={this.state.aryAutoSuggestDepositNames} />}
		</div>);
	}
}

export default WalletName;
